<p-toast position="top-right" [life]="5000"></p-toast>

<p-button
  (click)="open()"
  [icon]="getButtonIcon()"
  [severity]="getButtonSeverity()"
  *ngIf="entityType != null && entityId"
  [title]="getButtonTitle()">
</p-button>

<p-drawer [(visible)]="visible" [header]="'INSZoom Data Migration Review'" position="right" [modal]="true" [style]="{ width: '40rem' }">
  <!-- Debug information (optional, can be removed in production) -->
  <div class="mb-2 p-2 bg-blue-50 text-xs text-gray-600 rounded" *ngIf="false">
    {{ getDebugInfo() }}
  </div>

  <ng-container *ngIf="!loading; else loadingTemplate">


    <form [formGroup]="legacyReviewForm" class="p-fluid grid">
      <div class="col-12">
        <div class="field">
          <label for="formId">Notes</label>
        <textarea
          id="notes"
          formControlName="notes"
          rows="15"
          class="w-full p-2 border border-gray-300 rounded"
          maxlength="1024"
          placeholder="Enter review notes here..."></textarea>
        <small *ngIf="legacyReviewForm.get('notes')?.invalid && legacyReviewForm.get('notes')?.touched" class="p-error block">
          Notes too long (max 1024 characters)
        </small>
      </div>
      </div>
      <div class="col-12">
        <div class="field">
          <label for="formId">Status</label>
        <p-dropdown
          id="status"
          formControlName="status"
          [options]="statusOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select status"
          class="w-full">
        </p-dropdown>
        <small *ngIf="legacyReviewForm.get('status')?.invalid && legacyReviewForm.get('status')?.touched" class="p-error block">
          Status is required
        </small>
      </div>
      </div>
    </form>

    <!-- Action Buttons -->
    <div class="flex justify-content-end gap-2 mt-4">
      <p-button label="Cancel" severity="secondary" (click)="onCancel()" [disabled]="saving"></p-button>
      <p-button label="Save" severity="primary" (click)="onSave()" [loading]="saving" [disabled]="legacyReviewForm.invalid || !actualEntityId"></p-button>
    </div>
    <div class="mt-2" *ngIf="isEditMode && currentLegacyReview">
    <div class="grid">
      <div class="col-12">
        <strong>Created by </strong>
        {{ currentLegacyReview.creatorBy || "" }}
        <strong>on </strong>
        {{ formatDate(currentLegacyReview.creationTime) }}
      </div>
      <div class="col-12" *ngIf="currentLegacyReview.lastModificationTime">
        <strong>Modified by </strong>
        {{ currentLegacyReview.lastModifierBy || "" }}
        <strong>on </strong>
        {{formatDate( currentLegacyReview.lastModificationTime)}}
      </div>
    </div>
  </div>
  </ng-container>


  <ng-template #loadingTemplate>
    <div class="flex align-items-center justify-content-center h-20rem">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      <span class="ml-2">Loading...</span>
    </div>
  </ng-template>
</p-drawer>
